export const businessUnitPropsConstants = {
  LOAD_BUSINESS_UNIT_PROPS: "LOAD_BUSINESS_UNIT_PROPS",
  CHANGE_BUSINESS_UNIT_PROP: "CHANGE_BUSINESS_UNIT_PROP_OCCUPATION_BUSINESS_UNIT",
  CLEAR_BUSINESS_UNIT_PROP: "CLEAR_BUSINESS_UNIT_PROP_LOCAL",
  CLEAR_ALL_BUSINESS_UNIT_PROP: "CLEAR_ALL_BUSINESS_UNIT_PROP",
}